export default __webpack_public_path__ + "static/media/img4.8cb53a14.jpg";